import React, { useState } from "react";
import BottomNav from "./BottomNav.tsx";
import PdfViewer from "./PdfViewer.tsx";

interface PdfDocumentLayoutProps {
  title?: string;
  fallbackTitle: string;
  description?: string;
  authorName?: string;
  authorEmail?: string;
  fileUrl: string;
  hasDocument: boolean;
  emptyMessage: string;
}

const PdfDocumentLayout: React.FC<PdfDocumentLayoutProps> = ({
  title,
  fallbackTitle,
  description,
  authorName,
  authorEmail,
  fileUrl,
  hasDocument,
  emptyMessage,
}) => {
  const [showUi, setShowUi] = useState<boolean>(true);

  return (
    <div className={`min-h-screen bg-white ${showUi ? "pb-20" : "pb-0"} flex flex-col relative`}>
      <button
        type="button"
        onClick={() => setShowUi((prev) => !prev)}
        className="fixed top-4 right-4 z-30 px-4 py-2 rounded-full bg-blue-900 text-white text-sm font-semibold shadow-lg"
      >
        {showUi ? "Hide UI" : "Show UI"}
      </button>

      {showUi && (
        <div className="px-5 pt-2">
          <h1 className="text-blue-900 font-bold text-lg font-medium">
            {title || fallbackTitle}
          </h1>
          {description && (
            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600">
              {description}
            </p>
          )}
          {(authorName || authorEmail) && (
            <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500">
              {authorName && (
                <span>
                  <span className="font-semibold text-slate-700">Author:</span> {authorName}
                </span>
              )}
              {authorEmail && (
                <span>
                  <span className="font-semibold text-slate-700">Email:</span> {authorEmail}
                </span>
              )}
            </div>
          )}
        </div>
      )}

      <div className="flex-1 overflow-hidden p-4">
        <div className="bg-white ring-white-500 rounded-t-3xl p-2">
          {hasDocument ? (
            <PdfViewer
              fileUrl={fileUrl}
              showControls={showUi}
              className={showUi ? "h-[calc(100vh-210px)]" : "h-[calc(100vh-40px)]"}
            />
          ) : (
            <div className="p-6 text-center text-gray-600">{emptyMessage}</div>
          )}
        </div>
      </div>

      {showUi && <BottomNav showBack={true} />}
    </div>
  );
};

export default PdfDocumentLayout;
